type CONFIG = {
    API_URL: string | undefined,
    ADMIN_TOKEN: string | undefined
    URL: string | undefined
};

const config: CONFIG = {
    API_URL: process.env.REACT_APP_API_URL,
    ADMIN_TOKEN: process.env.REACT_APP_ADMIN_TOKEN,
    URL: process.env.REACT_APP_URL
};

export default config;
